import Flickity from 'flickity';

export default {
  init($element) {
  },
  finalize($element) {
    // Initialise anchor links carousel, if applicable
    const $anchorLinksCarousel = $element.find('.anchor-links-carousel');
    if ($anchorLinksCarousel.length > 0) {
      const anchorLinksFlickity = new Flickity($anchorLinksCarousel.get()[0], {
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        cellAlign: 'left',
      });

      // On scroll set currently active anchor link where appropriate
      var allAnchorLinks = [];
      var currentlyActiveAnchorLink = -1;

      setTimeout(() => {
        $('.shared-anchor-link').each(function() {
          let thisAnchorLink = {
            slug: $(this).find('a').prop('name'),
            y: $(this).find('a').offset().top,
          };

          allAnchorLinks.push(thisAnchorLink);
        });

        $anchorLinksCarousel.css({ 'visibility': 'visible' });
      }, 500);

      $(window).on('scroll', function() {
        const scrollY = $(document).scrollTop();
        currentlyActiveAnchorLink = -1;

        allAnchorLinks.forEach((anchorLink, index) => {
          if (scrollY + 80 >= anchorLink.y) {
            currentlyActiveAnchorLink = index;
          }
        });

        // Remove all active classes from anchor bar
        $element.find('.anchor-link').removeClass('is-active');

        if (currentlyActiveAnchorLink > -1) {
          $element.find(`.anchor-link[href="#${allAnchorLinks[currentlyActiveAnchorLink].slug}"]`).addClass('is-active');
        }
      });

      // Sometimes anchor links don't work on some browsers so this has been rewritten with JS
      $element.find('.anchor-link').each(function() {
        $(this).on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const linkName = $(this).attr('href').replaceAll('#', '');
          const $linkLocation = $(`a[name="${linkName}"]`);

          if ($linkLocation.length) {
            const linkY = $linkLocation.offset().top;
            window.scrollTo(0, linkY);
          }
        });
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/anchorLinks.js